<template>
  <div class="w-100 global-asset-item">
    <vx-card :class="assetClassName" class="d-flex w-100">
      <slot />
      <div slot="no-body" class="card-img-block">
        <HoverThumb
          imgClassName="responsive card-img-top"
          :asset="item"
          :main="getThumbnail(item)"
          :list="getThumbnails(item)" />
        <vs-chip
          :color="['video', 'animation'].indexOf(item.asset_type) !== -1 ? 'danger' : ['image', 'illustration'].indexOf(item.asset_type) !== -1 ? 'success' : 'primary'"
          class="item-category">{{ getTypeName(item) }}
        </vs-chip>
        <vs-chip color="primary" class="item-type"
                 v-if="item.variants && item.variants.length && item.variants.length > 1">{{ item.variants.length }}
        </vs-chip>
      </div>
      <h5 class="mb-2" v-html="getTitle(item)" />
      <p class="text-grey asset-desc" v-html="getDescription(item)" />
      <div class="footer pt-4 mt-auto d-flex" v-if="showFooter">
          <div class="w-1/2 pr-1">
            <vs-button class="w-100 px-2" type="gradient" color="#7367F0" gradient-color-secondary="#CE9FFC"
                       @click="onPreview(item)">Preview
            </vs-button>
          </div>
          <div class="w-1/2 pl-1">
            <vs-button class="w-100 px-2" type="gradient" color="#7367F0" gradient-color-secondary="#CE9FFC"
                       @click="onSelect(item)">Select
            </vs-button>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import HoverThumb from "./HoverThumb.vue";

export default {
  components: {
    HoverThumb,
  },
  props: {
    item: {type: Object},
    showFooter: {type: Boolean, default: false},
    onPreview: {type: Function, default: () => null},
    onSelect: {type: Function, default: () => null},
    isMyLibrary: {type: Boolean, default: false},
    showImages: {type: Boolean, default: true}
  },
  data() {
    return {
      customAssetTypes: {
        activities: 'Activity',
        questions: 'Question',
        simulations: 'Virtual Labs',
        coobos: 'Lesson',
        videos: 'Video',
      }
    }
  },
  computed: {
    assetClassName() {
      let item = this.item;
      let classNames = [];
      classNames.push('type-' + (item.asset_type || "").replace(' ', ''))
      // if (!item.asset_object_id && (!item.variants || !item.variants.length)) {
      //   classNames.push("is-empty");
      // }
      // if (!item.thumbnail && item.variants && item.variants.length && item.variants.filter(v=> v.ready_links && v.ready_links.length).length) {
      //     classNames.push("is-pending");
      // }
      return classNames.join(" ")
    }
  },
  mounted() {
  },
  methods: {
    removeHTMLandImgLinks(inputString) {
      return inputString.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').replace(/&amp;/g, '&');
    },
    getTypeName(item) {
      if (!item.asset_type) return "";
      let type = (item.quizType ? `Activity` : null) || this.$store.state.assetTypes[item.asset_type] || this.customAssetTypes[item.subtype];
      if (item.variants_data && item.asset_type === '3D' && item.variants_data.is_animated) {
        type = 'Animated ' + type;
      }

      return type;
    },
    getTitle(item) {
      let t = ''
      if (item.title) {
        t = item.title
      }
      if (item.question_txt) {
        t = item.question_txt;
      }


      return this.removeHTMLandImgLinks(t);
    },
    getDescription(item) {
      let d = '';
      if (item.description) {
        d = item.description
      }

      return this.removeHTMLandImgLinks(d);
    },
    getThumbnail(item) {
      if (item.thumbnail) {
        return item.thumbnail
      }
    },
    getThumbnails(item) {
      if (item.thumbnails) {
        return item.thumbnails
      }

      return [];
    },
  },
}
</script>

<style>
.global-asset-item .vx-card .vx-card__collapsible-content {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.global-asset-item .card-img-block {
  flex-grow: 0;
}
.global-asset-item .vx-card__body {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}
.global-asset-item button.isActive:not(.selected) .vs-button-text.vs-button--text {
  color: inherit !important;
}
</style>
